@if (isVisible()) {
<div class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/20">
<div class="flex flex-col items-center">

    <!-- Spinner -->
    <div class="loader-spinner">
        @for (dot of dots; track $index) {
        <span class="loader-dot" [style.transform]="'rotate(' + ($index * 30) + 'deg)'">
            <span class="loader-dot-inner" [style.animationDelay]="($index * 0.12) + 's'"></span>
        </span>
        }
    </div>

    <!-- Text -->
    <h2 class="mt-5 text-2xl font-semibold text-white">
        {{ message() }}
    </h2>
</div>
</div>
}